export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type AdditionalDeliveryField = {
  __typename?: 'AdditionalDeliveryField';
  name: Maybe<Scalars['String']['output']>;
};

export type Age = {
  __typename?: 'Age';
  a: Maybe<Scalars['Int']['output']>;
  b: Maybe<Scalars['Int']['output']>;
};

export type AuthStatus = {
  __typename?: 'AuthStatus';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type AutoSellConfig = {
  __typename?: 'AutoSellConfig';
  organizationId: Maybe<Scalars['ID']['output']>;
  verificationMode: Maybe<AutoSellOrderVerificationMode>;
  verifyOrders: Maybe<Scalars['Boolean']['output']>;
};

export enum AutoSellOrderVerificationMode {
  All = 'All',
  None = 'None',
  WithComment = 'WithComment',
}

export type BasicSessionPrice = {
  __typename?: 'BasicSessionPrice';
  alreadyPaid: Maybe<Scalars['Boolean']['output']>;
  isSet: Maybe<Scalars['Boolean']['output']>;
  paidOnline: Maybe<Scalars['Boolean']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
};

export type BasicSessionPriceInput = {
  alreadyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  paidOnline?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
};

export type BasketDetails = {
  calendars?: InputMaybe<Array<InputMaybe<OrderCalendarInBasket>>>;
  files?: InputMaybe<Array<InputMaybe<OrderFileInBasket>>>;
  frames?: InputMaybe<Array<InputMaybe<OrderPrintFrameInBasket>>>;
  lookBookProducts?: InputMaybe<
    Array<InputMaybe<LookBookProductInBasketForOrder>>
  >;
  magnets?: InputMaybe<Array<InputMaybe<OrderMagnetInBasket>>>;
  packages?: InputMaybe<Array<InputMaybe<PackageInBasket>>>;
  prints?: InputMaybe<Array<InputMaybe<OrderPrintInBasket>>>;
  products?: InputMaybe<Array<InputMaybe<OrderProductInBasket>>>;
  tablo?: InputMaybe<Array<InputMaybe<OrderTabloInBasket>>>;
};

export type BlackFridayStatus = {
  __typename?: 'BlackFridayStatus';
  postponed: Maybe<Scalars['Boolean']['output']>;
  used: Maybe<Scalars['Boolean']['output']>;
};

export type BookingCategorySortInput = {
  order: Scalars['Int']['input'];
  sessionCategoryId: Scalars['String']['input'];
};

export type BookingConfig = {
  __typename?: 'BookingConfig';
  banner: Maybe<CoverSetup>;
  personalization: Maybe<Scalars['String']['output']>;
};

export type BookingConfigInput = {
  banner?: InputMaybe<CoverUpdateDetails>;
  personalization?: InputMaybe<Scalars['String']['input']>;
};

export type BookingPackageAddition = {
  __typename?: 'BookingPackageAddition';
  affectDuration: Maybe<Scalars['Boolean']['output']>;
  affectPrice: Maybe<Scalars['Boolean']['output']>;
  bookingPackageAdditionId: Maybe<Scalars['ID']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  duration: Maybe<Scalars['Int']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
};

export type BookingPackageAdditionInput = {
  affectDuration?: InputMaybe<Scalars['Boolean']['input']>;
  affectPrice?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  title?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
};

export type BookingPackageComponent = {
  __typename?: 'BookingPackageComponent';
  addToAll: Maybe<Scalars['Boolean']['output']>;
  bookingPackageComponentId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  value: Maybe<Array<Maybe<CustomLabel>>>;
};

export type BookingPackageComponentInput = {
  addToAll?: InputMaybe<Scalars['Boolean']['input']>;
  bookingPackageComponentId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  value?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
};

export type BookingPackageSortInput = {
  order: Scalars['Int']['input'];
  photoPackageId: Scalars['String']['input'];
};

export type BookingPhotoPackage = {
  __typename?: 'BookingPhotoPackage';
  afterTime: Maybe<Scalars['Int']['output']>;
  afterTimeActive: Maybe<Scalars['Boolean']['output']>;
  availableBookingPackageAdditions: Maybe<
    Array<Maybe<UsedBookingPackageAddition>>
  >;
  beforeTime: Maybe<Scalars['Int']['output']>;
  beforeTimeActive: Maybe<Scalars['Boolean']['output']>;
  bookingPhotoPackageId: Maybe<Scalars['ID']['output']>;
  color: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['ID']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  level: Maybe<Scalars['Int']['output']>;
  locksDayAfter: Maybe<Scalars['Boolean']['output']>;
  marketingDescription: Maybe<Scalars['String']['output']>;
  messageToClient: Maybe<Array<Maybe<CustomLabel>>>;
  packageTraits: Maybe<Array<Maybe<PackageTrait>>>;
  preReservationBuffer: Maybe<Scalars['Int']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  recommended: Maybe<Scalars['Boolean']['output']>;
  settlements: Maybe<PrivateSessionSettlements>;
  slotOnly: Maybe<Scalars['Boolean']['output']>;
  timeToConfirm: Maybe<Scalars['Int']['output']>;
  title: Maybe<Array<Maybe<CustomLabel>>>;
};

export type BookingPhotoPackageInput = {
  afterTime?: InputMaybe<Scalars['Int']['input']>;
  afterTimeActive?: InputMaybe<Scalars['Boolean']['input']>;
  availableBookingPackageAdditions?: InputMaybe<
    Array<InputMaybe<UsedBookingPackageAdditionInput>>
  >;
  beforeTime?: InputMaybe<Scalars['Int']['input']>;
  beforeTimeActive?: InputMaybe<Scalars['Boolean']['input']>;
  bookingPhotoPackageId?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  locksDayAfter?: InputMaybe<Scalars['Boolean']['input']>;
  marketingDescription?: InputMaybe<Scalars['String']['input']>;
  messageToClient?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  packageTraits?: InputMaybe<Array<InputMaybe<PackageTraitInput>>>;
  preReservationBuffer?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  settlements?: InputMaybe<PrivateSessionSettlementsInput>;
  slotOnly?: InputMaybe<Scalars['Boolean']['input']>;
  timeToConfirm?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
};

export type BookingPhotographerSortInput = {
  order: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type BookingSessionCategory = {
  __typename?: 'BookingSessionCategory';
  bookingPackageComponents: Maybe<Array<Maybe<BookingPackageComponent>>>;
  bookingSessionCategoryId: Maybe<Scalars['ID']['output']>;
  cover: Maybe<CoverSetup>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  imagesCount: Maybe<ImagesCount>;
  order: Maybe<Scalars['Int']['output']>;
  parentId: Maybe<Scalars['ID']['output']>;
  photoPackages: Maybe<Array<Maybe<BookingPhotoPackage>>>;
  title: Maybe<Array<Maybe<CustomLabel>>>;
  visualPersonalization: Maybe<Scalars['String']['output']>;
};

export type BookingSessionCategoryInput = {
  bookingPackageComponents?: InputMaybe<
    Array<InputMaybe<BookingPackageComponentInput>>
  >;
  cover?: InputMaybe<CoverUpdateDetails>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  photoPackages?: InputMaybe<Array<InputMaybe<BookingPhotoPackageInput>>>;
  title?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  visualPersonalization?: InputMaybe<Scalars['String']['input']>;
};

export type BookingSessionCategoryInsert = {
  bookingSessionCategoryId?: InputMaybe<Scalars['ID']['input']>;
  cover?: InputMaybe<CoverUpdateDetails>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
};

export type BuyerDetails = {
  __typename?: 'BuyerDetails';
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type CalendarForDisplay = {
  __typename?: 'CalendarForDisplay';
  calendarForDisplayId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<CalendarSize>;
};

export enum CalendarSize {
  S20x30 = 's20x30',
  S30x45 = 's30x45',
}

export type CloudAccessToken = {
  __typename?: 'CloudAccessToken';
  container: Maybe<Scalars['String']['output']>;
  filename: Maybe<Scalars['String']['output']>;
  storageAccessToken: Maybe<Scalars['String']['output']>;
  storageUri: Maybe<Scalars['String']['output']>;
  zalamoToken: Maybe<Scalars['String']['output']>;
};

export type ConfirmDataProcessingAgreementSigningInput = {
  agreementId: Scalars['ID']['input'];
  codes: Array<InputMaybe<DataProcessingAgreementSmsCodeInput>>;
};

export type CoverSetup = {
  __typename?: 'CoverSetup';
  coverSetupId: Maybe<Scalars['ID']['output']>;
  file: Maybe<Scalars['String']['output']>;
  size: Maybe<CoverSize>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type CoverSize = {
  __typename?: 'CoverSize';
  h: Maybe<Scalars['Int']['output']>;
  w: Maybe<Scalars['Int']['output']>;
};

export type CoverSizeInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
};

export type CoverUpdateDetails = {
  file: Scalars['String']['input'];
  size: CoverSizeInput;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateUploadQueueFileInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  maxSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overwrittenPhotoId?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  photoId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUploadQueueInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  filesCount?: InputMaybe<Scalars['Int']['input']>;
  filesDone?: InputMaybe<Scalars['Int']['input']>;
  isRetouched?: InputMaybe<Scalars['Boolean']['input']>;
  onDone?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  queueId: Scalars['String']['input'];
  type?: InputMaybe<UploadType>;
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  language: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CustomLabelInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type Data = {
  id: Maybe<Scalars['String']['output']>;
};

export type DataAgreementDetails = {
  __typename?: 'DataAgreementDetails';
  companyBuildingNumber: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyFlatNumber: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyStreet: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
  companyZipCode: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
};

export type DataAgreementDetailsInput = {
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
};

export type DataProcessingAgreement = {
  __typename?: 'DataProcessingAgreement';
  agreementId: Maybe<Scalars['ID']['output']>;
  businessType: Maybe<DataProcessingAgreementBusinessType>;
  created: Maybe<Scalars['Float']['output']>;
  dataAgreementDetails: Maybe<DataAgreementDetails>;
  organizationId: Maybe<Scalars['ID']['output']>;
  representatives: Maybe<Array<Maybe<DataProcessingAgreementRepresentative>>>;
  signedAt: Maybe<Scalars['Float']['output']>;
  status: Maybe<DataProcessingAgreementStatus>;
  tosContent: Maybe<Array<Maybe<CustomLabel>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  tosRevisionCreated: Maybe<Scalars['Float']['output']>;
  tosRevisionId: Maybe<Scalars['ID']['output']>;
  updated: Maybe<Scalars['Float']['output']>;
};

export enum DataProcessingAgreementBusinessType {
  Company = 'COMPANY',
  Unregistered = 'UNREGISTERED',
}

export type DataProcessingAgreementDraft = {
  __typename?: 'DataProcessingAgreementDraft';
  businessType: Maybe<DataProcessingAgreementBusinessType>;
  dataAgreementDetails: Maybe<DataAgreementDetails>;
  organizationId: Maybe<Scalars['ID']['output']>;
  representatives: Maybe<
    Array<Maybe<DataProcessingAgreementDraftRepresentative>>
  >;
};

export type DataProcessingAgreementDraftRepresentative = {
  __typename?: 'DataProcessingAgreementDraftRepresentative';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type DataProcessingAgreementRepresentative = {
  __typename?: 'DataProcessingAgreementRepresentative';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  pesel: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  verified: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementRepresentativeInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type DataProcessingAgreementSigningConfirmResult = {
  __typename?: 'DataProcessingAgreementSigningConfirmResult';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementSigningStartResult = {
  __typename?: 'DataProcessingAgreementSigningStartResult';
  agreementId: Maybe<Scalars['ID']['output']>;
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type DataProcessingAgreementSmsCodeInput = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum DataProcessingAgreementStatus {
  Pending = 'PENDING',
  Signed = 'SIGNED',
}

export type DataProcessingAgreementTosPreview = {
  __typename?: 'DataProcessingAgreementTosPreview';
  content: Maybe<Array<Maybe<CustomLabel>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  tosRevisionId: Maybe<Scalars['ID']['output']>;
};

export enum DeadlineScenario {
  Deadline = 'Deadline',
  Timeout = 'Timeout',
  Unlimited = 'Unlimited',
}

export type DecorationField = {
  __typename?: 'DecorationField';
  decorationFieldId: Maybe<Scalars['ID']['output']>;
  types: Maybe<Array<Maybe<DecorationFieldType>>>;
};

export enum DecorationFieldType {
  Connector = 'Connector',
  Date = 'Date',
  FirstName = 'FirstName',
  FirstNameInitial = 'FirstNameInitial',
  SecondName = 'SecondName',
  SecondNameInitial = 'SecondNameInitial',
}

export type DecorationForClient = {
  __typename?: 'DecorationForClient';
  decorationForClientId: Maybe<Scalars['ID']['output']>;
  fields: Maybe<Array<Maybe<DecorationField>>>;
};

export type DecorationPreConfig = {
  __typename?: 'DecorationPreConfig';
  connector: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  decorationPreConfigId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  secondName: Maybe<Scalars['String']['output']>;
};

export type DecorationPreConfigForClient = {
  __typename?: 'DecorationPreConfigForClient';
  connector: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  decorationPreConfigForClientId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  secondName: Maybe<Scalars['String']['output']>;
};

export type DecorationPreConfigInput = {
  connector: Scalars['String']['input'];
  date: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  secondName: Scalars['String']['input'];
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  additional: Maybe<Scalars['String']['output']>;
  buildingNumber: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  deliveryAddressId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  flatNumber: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
};

export type DeliveryMethod = {
  __typename?: 'DeliveryMethod';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  context: Maybe<Array<Maybe<DeliveryMethodContext>>>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  easyPackOrgId: Maybe<Scalars['ID']['output']>;
  easyPackToken: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryMethodContext {
  EmbedStore = 'EmbedStore',
  Lab = 'Lab',
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  Wedding = 'Wedding',
}

export type DeliveryMethodForDisplay = {
  __typename?: 'DeliveryMethodForDisplay';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  isAutoSell: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryType {
  Courier = 'Courier',
  Digital = 'Digital',
  EasyPack24 = 'EasyPack24',
  Pickup = 'Pickup',
}

export type DeviceLoggedOutEvent = {
  __typename?: 'DeviceLoggedOutEvent';
  deviceId: Scalars['ID']['output'];
  occurredAt: Scalars['Int']['output'];
};

export type FileForUpload = {
  fileName: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  isOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  originalHeight?: InputMaybe<Scalars['Int']['input']>;
  originalName: Scalars['String']['input'];
  originalWidth?: InputMaybe<Scalars['Int']['input']>;
  overwrittenPhotoId?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  photoId: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type FileForUploadByLocalClient = {
  fileName: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  isOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  isRaw: Scalars['Boolean']['input'];
  originalName: Scalars['String']['input'];
  overwrittenPhotoId?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  photoId: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type FilePricing = {
  __typename?: 'FilePricing';
  filePricingId: Maybe<Scalars['String']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printsIncluded: Maybe<Array<Maybe<PrintsCount>>>;
  size: Maybe<Scalars['Int']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type FilePricingInput = {
  filePricingId: Scalars['String']['input'];
  isFull: Scalars['Boolean']['input'];
  price: Array<InputMaybe<PriceConfigInput>>;
  printsIncluded: Array<InputMaybe<UpdatePrintsCount>>;
  size: Scalars['Int']['input'];
  stepPricing: StepPricingInput;
  stepPricingEnabled: Scalars['Boolean']['input'];
};

export type FileWatermark = {
  __typename?: 'FileWatermark';
  fileName: Maybe<Scalars['ID']['output']>;
  fileWatermarkId: Maybe<Scalars['ID']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type FileWatermarkInput = {
  fileName: Scalars['ID']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum FilesAndPrintsPackageType {
  AnyImage = 'AnyImage',
  OneImage = 'OneImage',
  PickedImage = 'PickedImage',
}

export type FilesConfig = {
  __typename?: 'FilesConfig';
  count: Maybe<Scalars['Int']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['Int']['output']>;
};

export type ForcedImageConfig = {
  __typename?: 'ForcedImageConfig';
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type ForcedImageConfigUpdate = {
  photoGroupId?: InputMaybe<Scalars['ID']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
};

export type FramesOrder = {
  __typename?: 'FramesOrder';
  hash: Maybe<Scalars['String']['output']>;
  orderNumber: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type FramesOrderInput = {
  black?: InputMaybe<Scalars['Int']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientFirstName?: InputMaybe<Scalars['String']['input']>;
  clientLastName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSameAsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryFlatNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  deliveryZipCode?: InputMaybe<Scalars['String']['input']>;
  lockerAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lockerId?: InputMaybe<Scalars['String']['input']>;
  white?: InputMaybe<Scalars['Int']['input']>;
};

export enum GroupImagesByPeopleTypeForDisplay {
  FirstName = 'FirstName',
  FullName = 'FullName',
}

export type ImageContainer = {
  __typename?: 'ImageContainer';
  images: Maybe<ImageList>;
  imagesCount: Maybe<Scalars['Int']['output']>;
  label: Maybe<Array<Maybe<CustomLabel>>>;
  photoGroupId: Maybe<Scalars['ID']['output']>;
  type: Maybe<ImagesContainer>;
  typeId: Maybe<Scalars['ID']['output']>;
};

export type ImageForDisplay = {
  __typename?: 'ImageForDisplay';
  height: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoGroupHasPhotoId: Scalars['String']['output'];
  photoGroupId: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type ImageList = {
  __typename?: 'ImageList';
  files: Maybe<Array<Maybe<PhotoInGroup>>>;
  imageListId: Maybe<Scalars['ID']['output']>;
  imagesCount: Maybe<ImagesCount>;
  suggestions: Maybe<Array<Maybe<ImageSuggestion>>>;
};

export type ImageSuggestion = {
  __typename?: 'ImageSuggestion';
  comment: Maybe<Array<Maybe<CustomLabel>>>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export enum ImagesContainer {
  AlbumDesign = 'AlbumDesign',
  BookingPortfolio = 'BookingPortfolio',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionSignupCampaignPortfolio = 'PublicSessionSignupCampaignPortfolio',
  PublicSessionSignupPackagePortfolio = 'PublicSessionSignupPackagePortfolio',
  Wedding = 'Wedding',
}

export type ImagesCount = {
  __typename?: 'ImagesCount';
  all: Maybe<Scalars['Int']['output']>;
  hasPeople: Maybe<Scalars['Boolean']['output']>;
  imagesCountId: Maybe<Scalars['ID']['output']>;
  uploadInProgress: Maybe<Scalars['Int']['output']>;
};

export type InsertedImageList = {
  __typename?: 'InsertedImageList';
  files: Maybe<Array<Maybe<PhotoInGroup>>>;
  id: Maybe<Scalars['String']['output']>;
  imagesCount: Maybe<ImagesCount>;
};

export type InsertedImageListByLocalClient = {
  __typename?: 'InsertedImageListByLocalClient';
  files: Maybe<Array<Maybe<PhotoInGroup>>>;
  id: Maybe<Scalars['String']['output']>;
  imagesCount: Maybe<ImagesCount>;
  taskSet: Maybe<LocalClientTaskSet>;
  taskSetId: Maybe<Scalars['ID']['output']>;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  buyerEmail: Maybe<Scalars['String']['output']>;
  companyAddress: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyPostCode: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
};

export type InvoiceDetailsInput = {
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  requestInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KeywordsList = {
  __typename?: 'KeywordsList';
  keywordsListId: Maybe<Scalars['ID']['output']>;
  list: Maybe<Array<Maybe<PhotoKeywords>>>;
};

export type ListOfGroupsInSessionDisplay = {
  __typename?: 'ListOfGroupsInSessionDisplay';
  groups: Maybe<Array<Maybe<PublicSessionGroupForDisplay>>>;
  id: Maybe<Scalars['ID']['output']>;
  watermarkCacheBomb: Maybe<Scalars['String']['output']>;
};

export type LocalClient = {
  __typename?: 'LocalClient';
  config: Maybe<LocalClientConfig>;
  created: Maybe<Scalars['Int']['output']>;
  ignored: Maybe<Scalars['Boolean']['output']>;
  localClientId: Maybe<Scalars['ID']['output']>;
  secret: Maybe<Scalars['String']['output']>;
};

export type LocalClientConfig = {
  __typename?: 'LocalClientConfig';
  exportDigital: Maybe<Scalars['Boolean']['output']>;
  exportOrders: Maybe<Scalars['Boolean']['output']>;
  exportPrints: Maybe<Scalars['Boolean']['output']>;
  exportProducts: Maybe<Scalars['Boolean']['output']>;
  localClientConfigId: Maybe<Scalars['ID']['output']>;
  ordersExportPath: Maybe<Scalars['String']['output']>;
};

export type LocalClientConfigInput = {
  exportOrders: Scalars['Boolean']['input'];
  ordersExportPath?: InputMaybe<Scalars['String']['input']>;
};

export type LocalClientSubTask = {
  __typename?: 'LocalClientSubTask';
  arguments: Maybe<Scalars['String']['output']>;
  failCount: Maybe<Scalars['Int']['output']>;
  localClientSubTaskId: Maybe<Scalars['ID']['output']>;
  source: Maybe<Scalars['String']['output']>;
  sourceId: Maybe<Scalars['ID']['output']>;
};

export enum LocalClientTaskContext {
  BookingPortfolio = 'BookingPortfolio',
  ChatAttachment = 'ChatAttachment',
  ConfigTemplate = 'ConfigTemplate',
  CoverPrivate = 'CoverPrivate',
  CoverPublic = 'CoverPublic',
  DecorationFile = 'DecorationFile',
  DigitalOrder = 'DigitalOrder',
  FileWatermark = 'FileWatermark',
  LookBookPreview = 'LookBookPreview',
  Model3D = 'Model3D',
  Order = 'Order',
  OrganizationLogo = 'OrganizationLogo',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  PrivateSessionPackage = 'PrivateSessionPackage',
  Product = 'Product',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionPackage = 'PublicSessionPackage',
  PublicSessionSignupCampaignPortfolio = 'PublicSessionSignupCampaignPortfolio',
  PublicSessionSignupPackagePortfolio = 'PublicSessionSignupPackagePortfolio',
  SupplierPrintsOrder = 'SupplierPrintsOrder',
  SupplierProductOrder = 'SupplierProductOrder',
  UserAvatar = 'UserAvatar',
}

export type LocalClientTaskSet = {
  __typename?: 'LocalClientTaskSet';
  allTasks: Maybe<Scalars['Int']['output']>;
  context: Maybe<LocalClientTaskContext>;
  contextId: Maybe<Scalars['ID']['output']>;
  dir: Maybe<Scalars['String']['output']>;
  failCount: Maybe<Scalars['Int']['output']>;
  localClientId: Maybe<Scalars['ID']['output']>;
  localClientTaskSetId: Maybe<Scalars['Int']['output']>;
  taskName: Maybe<LocalClientTaskType>;
  unDoneTasks: Maybe<Scalars['Int']['output']>;
};

export enum LocalClientTaskType {
  OrderExport = 'OrderExport',
  UploadFull = 'UploadFull',
  UploadThumb = 'UploadThumb',
}

export type LockerAddressDetails = {
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
};

export type LockerDetailsInput = {
  address?: InputMaybe<LockerAddressDetails>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LookBookDetailsForClient = {
  __typename?: 'LookBookDetailsForClient';
  configs: Maybe<Array<Maybe<LookBookProductConfig>>>;
  decorationPreConfig: Maybe<DecorationPreConfigForClient>;
  labs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lookBookId: Maybe<Scalars['ID']['output']>;
  occasion: Maybe<LookBookOccasionForClient>;
  postOrderMessage: Maybe<Array<Maybe<CustomLabel>>>;
  spreadsCount: Maybe<Scalars['Int']['output']>;
  welcomeMessage: Maybe<Array<Maybe<CustomLabel>>>;
};

export type LookBookInBasketInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  countPhotos?: InputMaybe<LookBookProductImageLimitationInput>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  firstAddedFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPersonalization?: InputMaybe<Scalars['Boolean']['input']>;
  imageMap?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  lookBookProductConfigId?: InputMaybe<Scalars['ID']['input']>;
  lookBookProductId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  nameClientProduct?: InputMaybe<Scalars['String']['input']>;
  personalizationConfig?: InputMaybe<Scalars['String']['input']>;
  photoIdList?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  productsInPlay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  redBackground?: InputMaybe<Scalars['Boolean']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
  valueMap?: InputMaybe<Scalars['String']['input']>;
};

export enum LookBookOccasionForClient {
  ChildSession = 'ChildSession',
  CoupleAnniversary = 'CoupleAnniversary',
  FamilyEvent = 'FamilyEvent',
  FirstCommunion = 'FirstCommunion',
  OtherOccasion = 'OtherOccasion',
  Wedding = 'Wedding',
}

export enum LookBookPriceRounding {
  Five = 'Five',
  One = 'One',
  Ten = 'Ten',
}

export type LookBookProductColorDefinition = {
  __typename?: 'LookBookProductColorDefinition';
  colorId: Maybe<Scalars['ID']['output']>;
  label: Maybe<Array<Maybe<CustomLabel>>>;
};

export type LookBookProductConfig = {
  __typename?: 'LookBookProductConfig';
  config: Maybe<Scalars['String']['output']>;
  cost: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  count: Maybe<Scalars['Int']['output']>;
  created: Maybe<Scalars['Int']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  hasPersonalization: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  lookBookProductConfigId: Maybe<Scalars['ID']['output']>;
  personalizationConfig: Maybe<Scalars['String']['output']>;
  sent: Maybe<Scalars['Boolean']['output']>;
  sentWhen: Maybe<Scalars['Int']['output']>;
  thumb: Maybe<Scalars['String']['output']>;
};

export type LookBookProductConfigUpdate = {
  config?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
};

export type LookBookProductImageLimitation = {
  __typename?: 'LookBookProductImageLimitation';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type LookBookProductImageLimitationInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type LookBookProductInBasket = {
  __typename?: 'LookBookProductInBasket';
  accessToken: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  countPhotos: Maybe<LookBookProductImageLimitation>;
  finished: Maybe<Scalars['Boolean']['output']>;
  firstAddedFile: Maybe<Scalars['Boolean']['output']>;
  hasPersonalization: Maybe<Scalars['Boolean']['output']>;
  imageMap: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  lookBookProductConfigId: Maybe<Scalars['ID']['output']>;
  lookBookProductId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  nameClientProduct: Maybe<Scalars['String']['output']>;
  personalizationConfig: Maybe<Scalars['String']['output']>;
  photoIdList: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productsInPlay: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  quantity: Maybe<Scalars['Int']['output']>;
  redBackground: Maybe<Scalars['Boolean']['output']>;
  thumb: Maybe<Scalars['String']['output']>;
  timeAddedToShoppingCart: Maybe<Scalars['Int']['output']>;
  valueMap: Maybe<Scalars['String']['output']>;
};

export type LookBookProductInBasketForOrder = {
  config?: InputMaybe<Scalars['String']['input']>;
  hasPersonalization?: InputMaybe<Scalars['Boolean']['input']>;
  imageMap: Array<InputMaybe<WallDecorRenderPieceConfigInput>>;
  lookBookProductConfigId?: InputMaybe<Scalars['ID']['input']>;
  lookBookProductId?: InputMaybe<Scalars['ID']['input']>;
  personalizationConfig?: InputMaybe<Scalars['String']['input']>;
  photoIdList?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productsInPlay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
  valueMap?: InputMaybe<Scalars['String']['input']>;
};

export type LookBookProductMaterialDefinition = {
  __typename?: 'LookBookProductMaterialDefinition';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  materialId: Maybe<Scalars['ID']['output']>;
};

export type MagnetForDisplay = {
  __typename?: 'MagnetForDisplay';
  magnetForDisplayId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<MagnetSize>;
};

export enum MagnetSize {
  S6_67x10 = 's6_67x10',
  S10x15 = 's10x15',
}

export enum MonthRecurConfig {
  OnDayOfWeek = 'onDayOfWeek',
  OnNumber = 'onNumber',
}

export type Mutation = {
  __typename?: 'Mutation';
  addScheduleEventToPrivateSession: Maybe<ScheduleEvent>;
  insertBookingCategory: Maybe<BookingSessionCategory>;
  insertBookingPhotoAddition: Maybe<BookingPackageAddition>;
  insertScheduleEvent: Maybe<ScheduleEvent>;
  setBookingPreviewURL: Maybe<Scalars['String']['output']>;
  updateBookingCategoriesSortOrder: Maybe<MutationStatus>;
  updateBookingCategory: Maybe<BookingSessionCategory>;
  updateBookingConfig: Maybe<BookingConfig>;
  updateBookingPackagesSortOrder: Maybe<MutationStatus>;
  updateBookingPhotoAddition: Maybe<BookingPackageAddition>;
  updateBookingPhotographersSortOrder: Maybe<MutationStatus>;
  updateInvoiceDetails: Maybe<OrganizationInvoiceDetails>;
  updateMock: Maybe<Scalars['Int']['output']>;
  updateScheduleEvent: Maybe<ScheduleEvent>;
};

export type MutationAddScheduleEventToPrivateSessionArgs = {
  privateSessionId: Scalars['ID']['input'];
  scheduleEventId: Scalars['ID']['input'];
};

export type MutationInsertBookingCategoryArgs = {
  bookingSessionCategory: BookingSessionCategoryInsert;
  organizationId: Scalars['ID']['input'];
};

export type MutationInsertBookingPhotoAdditionArgs = {
  bookingPhotoAddition: BookingPackageAdditionInput;
  bookingPhotoPackageId: Scalars['ID']['input'];
};

export type MutationInsertScheduleEventArgs = {
  scheduleEvent: ScheduleEventInput;
  scheduleEventId: Scalars['ID']['input'];
};

export type MutationSetBookingPreviewUrlArgs = {
  bookingPreviewURL?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MutationUpdateBookingCategoriesSortOrderArgs = {
  bookingCategorySort?: InputMaybe<Array<InputMaybe<BookingCategorySortInput>>>;
};

export type MutationUpdateBookingCategoryArgs = {
  bookingSessionCategory: BookingSessionCategoryInput;
  bookingSessionCategoryId: Scalars['ID']['input'];
};

export type MutationUpdateBookingConfigArgs = {
  bookingConfig: BookingConfigInput;
  organizationId: Scalars['ID']['input'];
};

export type MutationUpdateBookingPackagesSortOrderArgs = {
  bookingPackageSort?: InputMaybe<Array<InputMaybe<BookingPackageSortInput>>>;
};

export type MutationUpdateBookingPhotoAdditionArgs = {
  bookingPhotoAddition: BookingPackageAdditionInput;
  bookingPhotoAdditionId: Scalars['ID']['input'];
};

export type MutationUpdateBookingPhotographersSortOrderArgs = {
  bookingPhotographerSort?: InputMaybe<
    Array<InputMaybe<BookingPhotographerSortInput>>
  >;
};

export type MutationUpdateInvoiceDetailsArgs = {
  organizationId: Scalars['ID']['input'];
  update: OrganizationInvoiceDetailsUpdate;
};

export type MutationUpdateScheduleEventArgs = {
  scheduleEvent: ScheduleEventInput;
  scheduleEventId: Scalars['ID']['input'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus2 = {
  __typename?: 'MutationStatus2';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NewShoppingCartOrderInput = {
  basket: BasketDetails;
  clientPermissions?: InputMaybe<Scalars['String']['input']>;
  context: OrderContext;
  contextId: Scalars['ID']['input'];
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  deliveryDetails: OrderDeliveryDetails;
  domain?: InputMaybe<Scalars['String']['input']>;
  invoiceDetails?: InputMaybe<InvoiceDetailsInput>;
  isTest: Scalars['Boolean']['input'];
  languageId?: InputMaybe<Scalars['ID']['input']>;
  mobileDeviceId?: InputMaybe<Scalars['ID']['input']>;
  mobileNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ownPhotos?: InputMaybe<Array<InputMaybe<OwnPhoto>>>;
  promoCode?: InputMaybe<Scalars['ID']['input']>;
};

export enum NiceUrlContainer {
  PublicSession = 'PublicSession',
}

export type NiceUrlValidationStatus = {
  __typename?: 'NiceUrlValidationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type OldPrivateSessionConfigTemplate = {
  __typename?: 'OldPrivateSessionConfigTemplate';
  configId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['ID']['output']>;
};

export type OnlinePayments = {
  __typename?: 'OnlinePayments';
  dotPay: Maybe<Scalars['Boolean']['output']>;
  isSet: Maybe<Scalars['Boolean']['output']>;
  payPal: Maybe<Scalars['Boolean']['output']>;
  przelewy24: Maybe<Scalars['Boolean']['output']>;
};

export type OnlinePaymentsInput = {
  dotPay?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  payPal?: InputMaybe<Scalars['Boolean']['input']>;
  przelewy24?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCalendarInBasket = {
  count: Scalars['Int']['input'];
  crop: WallDecorPieceCropInput;
  photoGroupId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  size: Scalars['ID']['input'];
  thumb: Scalars['String']['input'];
  timeAddedToShoppingCart: Scalars['Int']['input'];
};

export enum OrderContext {
  EmbedStore = 'EmbedStore',
  MarketplaceOrder = 'MarketplaceOrder',
  Order = 'Order',
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  SupplierOrder = 'SupplierOrder',
}

export type OrderDeliveryDetails = {
  additional?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  deliveryMethodId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  lockerDetails?: InputMaybe<LockerDetailsInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type OrderFileInBasket = {
  filePricingId?: InputMaybe<Scalars['ID']['input']>;
  isFull?: InputMaybe<Scalars['Boolean']['input']>;
  photoComments?: InputMaybe<Array<InputMaybe<PhotoCommentInput>>>;
  photoId: Scalars['ID']['input'];
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  retouchLevelId?: InputMaybe<Scalars['ID']['input']>;
  retouchPrice?: InputMaybe<Scalars['Int']['input']>;
  size: Scalars['Int']['input'];
  timeAddedToShoppingCart?: InputMaybe<Scalars['Int']['input']>;
  togetherWithPrint?: InputMaybe<Scalars['Boolean']['input']>;
  togetherWithProduct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderMagnetInBasket = {
  count: Scalars['Int']['input'];
  crop: Array<InputMaybe<Scalars['Float']['input']>>;
  photoGroupId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  size: Scalars['ID']['input'];
  thumb: Scalars['String']['input'];
  timeAddedToShoppingCart: Scalars['Int']['input'];
};

export type OrderPrintFrameInBasket = {
  count?: InputMaybe<Scalars['Int']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printFormatId?: InputMaybe<Scalars['ID']['input']>;
  printFrameId?: InputMaybe<Scalars['ID']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OrderPrintInBasket = {
  count: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  photoId: Scalars['ID']['input'];
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printFormatId: Scalars['ID']['input'];
  printId: Scalars['ID']['input'];
  printPaperId: Scalars['ID']['input'];
  timeAddedToShoppingCart?: InputMaybe<Scalars['Int']['input']>;
  togetherWithFile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderProductInBasket = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  firstAddedFile?: InputMaybe<Scalars['Boolean']['input']>;
  nameClientProduct?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  timeAddedToShoppingCart?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderTabloInBasket = {
  count: Scalars['Int']['input'];
  tabloForDisplayId: Scalars['ID']['input'];
  timeAddedToShoppingCart: Scalars['Int']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  subdomain: Maybe<Scalars['String']['output']>;
};

export type OrganizationInvoiceDetails = {
  __typename?: 'OrganizationInvoiceDetails';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  organizationInvoiceDetailsId: Maybe<Scalars['ID']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
};

export type OrganizationInvoiceDetailsUpdate = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

export type OwnPhoto = {
  count?: InputMaybe<Scalars['Int']['input']>;
  crop?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  height: Scalars['Int']['input'];
  originalName?: InputMaybe<Scalars['String']['input']>;
  ownPhotoId?: InputMaybe<Scalars['ID']['input']>;
  printFormatId?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  width: Scalars['Int']['input'];
};

export type PackageInBasket = {
  count?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<Array<InputMaybe<OrderFileInBasket>>>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
  packageInBasketId?: InputMaybe<Scalars['ID']['input']>;
  print?: InputMaybe<Array<InputMaybe<OrderPrintInBasket>>>;
  product?: InputMaybe<Array<InputMaybe<OrderProductInBasket>>>;
  timeAddedToShoppingCart?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageTrait = {
  __typename?: 'PackageTrait';
  active: Maybe<Scalars['Boolean']['output']>;
  bookingPackageComponentId: Maybe<Scalars['ID']['output']>;
  show: Maybe<Scalars['Boolean']['output']>;
  value: Maybe<Array<Maybe<CustomLabel>>>;
};

export type PackageTraitInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bookingPackageComponentId?: InputMaybe<Scalars['ID']['input']>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
};

export type PersonForPublicSession = {
  __typename?: 'PersonForPublicSession';
  id: Maybe<Scalars['ID']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type PersonToPhotoRelation = {
  __typename?: 'PersonToPhotoRelation';
  people: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  personToPhotoRelationId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type Photo = {
  __typename?: 'Photo';
  fileName: Maybe<Scalars['String']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type PhotoComment = {
  __typename?: 'PhotoComment';
  messages: Array<Maybe<PhotoCommentMessage>>;
  photoCommentId: Scalars['ID']['output'];
  photoId: Maybe<Scalars['ID']['output']>;
  position: Maybe<PhotoCommentPosition>;
  state: PhotoCommentState;
};

export type PhotoCommentInput = {
  messages: Array<InputMaybe<PhotoCommentMessageInput>>;
  photoCommentId: Scalars['ID']['input'];
  photoId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<PhotoCommentPositionInput>;
  state: PhotoCommentState;
};

export type PhotoCommentMessage = {
  __typename?: 'PhotoCommentMessage';
  author: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  posted: Scalars['Int']['output'];
};

export type PhotoCommentMessageInput = {
  author: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  posted: Scalars['Int']['input'];
};

export type PhotoCommentPosition = {
  __typename?: 'PhotoCommentPosition';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type PhotoCommentPositionInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export enum PhotoCommentState {
  Completed = 'Completed',
  InProgress = 'InProgress',
  Rejected = 'Rejected',
  Seen = 'Seen',
  Unseen = 'Unseen',
}

export type PhotoCommentUpdateInput = {
  messages?: InputMaybe<Array<InputMaybe<PhotoCommentMessageInput>>>;
  state?: InputMaybe<PhotoCommentState>;
};

export type PhotoInGroup = {
  __typename?: 'PhotoInGroup';
  order: Maybe<Scalars['Int']['output']>;
  photo: Maybe<SinglePhoto>;
  photoInGroupId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type PhotoKeywords = {
  __typename?: 'PhotoKeywords';
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type PhotoPackage = {
  __typename?: 'PhotoPackage';
  afterTime: Maybe<Scalars['Int']['output']>;
  beforeTime: Maybe<Scalars['Int']['output']>;
  color: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['ID']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  level: Maybe<Scalars['Int']['output']>;
  marketingDescription: Maybe<Scalars['String']['output']>;
  messageToClient: Maybe<Scalars['String']['output']>;
  photoPackageId: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  refundablePrepaid: Maybe<Scalars['Int']['output']>;
  sessionCategoryId: Maybe<Scalars['String']['output']>;
  slotOnly: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  timeToConfirm: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  unrefundablePrepaid: Maybe<Scalars['Int']['output']>;
};

export type PhotoUpdate = {
  height?: InputMaybe<Scalars['Int']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  originalHeight?: InputMaybe<Scalars['Int']['input']>;
  originalWidth?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoUpdateResult = {
  __typename?: 'PhotoUpdateResult';
  photo: Maybe<SinglePhoto>;
  photosInGroups: Maybe<Array<Maybe<PhotoInGroup>>>;
};

export type PhotoWithPeople = {
  __typename?: 'PhotoWithPeople';
  people: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type PhotographerAccount = {
  __typename?: 'PhotographerAccount';
  invoiceDetails: Maybe<OrganizationInvoiceDetails>;
  organization: Maybe<Organization>;
  photographerId: Maybe<Scalars['ID']['output']>;
  timeZone: Maybe<Scalars['ID']['output']>;
};

export type PhotographerAccountDetails = {
  __typename?: 'PhotographerAccountDetails';
  companyAddress: Maybe<Scalars['String']['output']>;
  companyCity: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  companyVatId: Maybe<Scalars['String']['output']>;
  companyZipCode: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  privateAddress: Maybe<Scalars['String']['output']>;
  privateCity: Maybe<Scalars['String']['output']>;
  privateCountry: Maybe<Scalars['String']['output']>;
  privateZipCode: Maybe<Scalars['String']['output']>;
};

export type PhotographerAccountDevice = {
  __typename?: 'PhotographerAccountDevice';
  deviceId: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['Int']['output']>;
};

export type PhotographerMobileNotificationsPairingToken = {
  __typename?: 'PhotographerMobileNotificationsPairingToken';
  expiresAt: Scalars['Int']['output'];
  token: Scalars['ID']['output'];
};

export type PlaceOrderOrderDetails = {
  __typename?: 'PlaceOrderOrderDetails';
  authToken: Maybe<Scalars['String']['output']>;
  hash: Maybe<Scalars['ID']['output']>;
  orderId: Maybe<Scalars['ID']['output']>;
  orderNumber: Maybe<Scalars['Int']['output']>;
  placed: Maybe<Scalars['Int']['output']>;
  sourceInactive: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Array<Maybe<StatusList>>>;
};

export enum PrepaidOptions {
  RefundablePrepaid = 'RefundablePrepaid',
  UnrefundablePrepaid = 'UnrefundablePrepaid',
}

export type PriceConfig = {
  __typename?: 'PriceConfig';
  code: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
};

export type PriceConfigInput = {
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
};

export type PriceListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  list?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
};

export type PriceStep = {
  __typename?: 'PriceStep';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  step: Maybe<Scalars['Int']['output']>;
};

export type PriceStepInput = {
  price: Array<InputMaybe<PriceConfigInput>>;
  step: Scalars['Int']['input'];
};

export type PrintAndFileConfig = {
  __typename?: 'PrintAndFileConfig';
  filesConfig: Maybe<Array<Maybe<FilesConfig>>>;
  forcedImage: Maybe<ForcedImageConfig>;
  groups: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mode: Maybe<FilesAndPrintsPackageType>;
  printAndFileConfigId: Maybe<Scalars['ID']['output']>;
  printsCount: Maybe<Array<Maybe<PrintsCount>>>;
};

export type PrintFormat = {
  __typename?: 'PrintFormat';
  label: Maybe<Scalars['String']['output']>;
  printFormatId: Maybe<Scalars['ID']['output']>;
};

export type PrintFrameInBasket = {
  __typename?: 'PrintFrameInBasket';
  count: Maybe<Scalars['Int']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printFrameId: Maybe<Scalars['ID']['output']>;
  ratio: Maybe<Scalars['Float']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type PrintFrameInBasketInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printFormatId?: InputMaybe<Scalars['ID']['input']>;
  printFrameId?: InputMaybe<Scalars['ID']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PrintPaper = {
  __typename?: 'PrintPaper';
  label: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
};

export type PrintPriceConfig = {
  __typename?: 'PrintPriceConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsConfig = {
  __typename?: 'PrintsConfig';
  formats: Maybe<Array<Maybe<PrintFormat>>>;
  papers: Maybe<Array<Maybe<PrintPaper>>>;
};

export type PrintsCount = {
  __typename?: 'PrintsCount';
  count: Maybe<Scalars['Int']['output']>;
  printFormatId: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['String']['output']>;
};

export enum PrintsPricingContext {
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  PublicSessionGroup = 'PublicSessionGroup',
  WeddingCouple = 'WeddingCouple',
  WeddingGallery = 'WeddingGallery',
}

export type PrintsPricingList = {
  __typename?: 'PrintsPricingList';
  context: Maybe<PrintsPricingContext>;
  label: Maybe<Scalars['String']['output']>;
  prices: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsPricingListForDisplay = {
  __typename?: 'PrintsPricingListForDisplay';
  list: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListForDisplayId: Maybe<Scalars['ID']['output']>;
};

export type PrivateSession = {
  __typename?: 'PrivateSession';
  acceptOnlinePayments: Maybe<Scalars['Boolean']['output']>;
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  allowComments: Maybe<Scalars['Boolean']['output']>;
  archived: Maybe<Scalars['Boolean']['output']>;
  autoSellConfig: Maybe<AutoSellConfig>;
  autoSellEnabled: Maybe<Scalars['Boolean']['output']>;
  clientPermissionsConfig: Maybe<Scalars['String']['output']>;
  configTemplateId: Maybe<Scalars['ID']['output']>;
  context: Maybe<PrivateSessionContext>;
  cover: Maybe<CoverSetup>;
  created: Maybe<Scalars['Int']['output']>;
  deadline: Maybe<Scalars['Int']['output']>;
  deadlineScenario: Maybe<DeadlineScenario>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  deliveryMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  digitalOrderForcePhone: Maybe<Scalars['Boolean']['output']>;
  duplicatesCount: Maybe<Scalars['Int']['output']>;
  enableFreeThumb: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  forceDisableFilesSales: Maybe<Scalars['Boolean']['output']>;
  forceDisablePrintsSales: Maybe<Scalars['Boolean']['output']>;
  forceDisableProductsSales: Maybe<Scalars['Boolean']['output']>;
  freePackageId: Maybe<Scalars['ID']['output']>;
  freeThumbSize: Maybe<Scalars['Int']['output']>;
  freeThumbWatermarkConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  groups: Maybe<Array<Maybe<PrivateSessionGroup>>>;
  hasOrder: Maybe<Scalars['Boolean']['output']>;
  internalCode: Maybe<Scalars['String']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  lookBookConfig: Maybe<SessionLookBookConfig>;
  lookBookEnabled: Maybe<Scalars['Boolean']['output']>;
  messages: Maybe<Array<Maybe<PrivateSessionMessage>>>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  organizationClientId: Maybe<Scalars['ID']['output']>;
  packages: Maybe<Array<Maybe<ProductPackage>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  privateSessionId: Maybe<Scalars['String']['output']>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publishDate: Maybe<Scalars['Int']['output']>;
  retouchLevels: Maybe<Array<Maybe<RetouchLevel>>>;
  retouchLevelsEnabled: Maybe<Scalars['Boolean']['output']>;
  salesMode: Maybe<PrivateSessionSalesMode>;
  scheduleEventId: Maybe<Scalars['ID']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellPackages: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  settlements: Maybe<PrivateSessionSettlements>;
  showFileNames: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipFavoriteInFileMode: Maybe<Scalars['Boolean']['output']>;
  soldFilesWatermarkConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  soldFilesWatermarked: Maybe<Scalars['Boolean']['output']>;
  soldWatermarkSize: Maybe<Scalars['Int']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  usePromoCodes: Maybe<Scalars['Boolean']['output']>;
  visualPersonalization: Maybe<Scalars['String']['output']>;
  watermarkConfig: Maybe<ProtectionWatermarkConfig>;
  watermarkEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type PrivateSessionAutoSellConfigInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  verificationMode?: InputMaybe<AutoSellOrderVerificationMode>;
  verifyOrders?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PrivateSessionContext {
  BirthdaySession = 'BirthdaySession',
  BusinessEvent = 'BusinessEvent',
  BusinessImage = 'BusinessImage',
  BusinessInteriorSession = 'BusinessInteriorSession',
  BusinessPortrait = 'BusinessPortrait',
  BusinessProduct = 'BusinessProduct',
  CompanyEvent = 'CompanyEvent',
  CompetitionBasketball = 'CompetitionBasketball',
  CompetitionBikeRiding = 'CompetitionBikeRiding',
  CompetitionDance = 'CompetitionDance',
  CompetitionFootball = 'CompetitionFootball',
  CompetitionHorseRiding = 'CompetitionHorseRiding',
  CompetitionRunning = 'CompetitionRunning',
  FamilyReportage = 'FamilyReportage',
  FamilySession = 'FamilySession',
  NewbornSession = 'NewbornSession',
  None = 'None',
  PregnancySession = 'PregnancySession',
  PrivateSession = 'PrivateSession',
  Prom = 'Prom',
  ReligionEventBaptism = 'ReligionEventBaptism',
  ReligionEventFirstCommunion = 'ReligionEventFirstCommunion',
  ReligionEventWedding = 'ReligionEventWedding',
  SchoolSession = 'SchoolSession',
  ShowCats = 'ShowCats',
  ShowDogs = 'ShowDogs',
  ShowHorses = 'ShowHorses',
  WomenSession = 'WomenSession',
}

export type PrivateSessionEvent = {
  __typename?: 'PrivateSessionEvent';
  deviceId: Maybe<Scalars['ID']['output']>;
  pageViewId: Maybe<Scalars['ID']['output']>;
  payload: Maybe<Scalars['String']['output']>;
  time: Maybe<Scalars['Float']['output']>;
  type: Maybe<PrivateSessionEventType>;
  visitId: Maybe<Scalars['ID']['output']>;
};

export enum PrivateSessionEventType {
  PageVisitEnd = 'PageVisitEnd',
  PageVisitStart = 'PageVisitStart',
  PhotoView = 'PhotoView',
}

export type PrivateSessionGroup = {
  __typename?: 'PrivateSessionGroup';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  customFilesPricing: Maybe<Scalars['Boolean']['output']>;
  customPrintsPricing: Maybe<Scalars['Boolean']['output']>;
  customProductsConfig: Maybe<Scalars['Boolean']['output']>;
  customWatermark: Maybe<Scalars['Boolean']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  imagesCount: Maybe<ImagesCount>;
  individualSellSettings: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  order: Maybe<Scalars['Int']['output']>;
  photoGroupId: Maybe<Scalars['String']['output']>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  privateSessionGroupId: Maybe<Scalars['String']['output']>;
  privateSessionId: Maybe<Scalars['String']['output']>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  soldFilesWatermarkConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  soldFilesWatermarked: Maybe<Scalars['Boolean']['output']>;
  soldWatermarkSize: Maybe<Scalars['Int']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  watermarkConfig: Maybe<ProtectionWatermarkConfig>;
};

export type PrivateSessionGroupUpdateInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  addPrintFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addToFirstPrintPrice?: InputMaybe<Scalars['Boolean']['input']>;
  customFilesPricing?: InputMaybe<Scalars['Boolean']['input']>;
  customPrintsPricing?: InputMaybe<Scalars['Boolean']['input']>;
  customProductsConfig?: InputMaybe<Scalars['Boolean']['input']>;
  customWatermark?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filePricing?: InputMaybe<Array<InputMaybe<FilePricingInput>>>;
  individualSellSettings?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  priceToAddToFirstPrint?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printsPricingListId?: InputMaybe<Scalars['ID']['input']>;
  productsSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sellFiles?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrints?: InputMaybe<Scalars['Boolean']['input']>;
  sellProducts?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  skipAddToFirstPrintIfFileBought?: InputMaybe<Scalars['Boolean']['input']>;
  soldFilesWatermarkConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  soldFilesWatermarked?: InputMaybe<Scalars['Boolean']['input']>;
  soldWatermarkSize?: InputMaybe<Scalars['Int']['input']>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  watermarkConfig?: InputMaybe<ProtectionWatermarkConfigInput>;
};

export type PrivateSessionInsertInput = {
  acceptOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  addPrintFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addToFirstPrintPrice?: InputMaybe<Scalars['Boolean']['input']>;
  autoSellConfig?: InputMaybe<PrivateSessionAutoSellConfigInput>;
  autoSellEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clientPermissionsConfig?: InputMaybe<Scalars['String']['input']>;
  configTemplateId?: InputMaybe<Scalars['ID']['input']>;
  context?: InputMaybe<PrivateSessionContext>;
  cover?: InputMaybe<CoverUpdateDetails>;
  created?: InputMaybe<Scalars['Int']['input']>;
  deliveryMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  digitalOrderForcePhone?: InputMaybe<Scalars['Boolean']['input']>;
  duplicatesCount?: InputMaybe<Scalars['Int']['input']>;
  enableFreeThumb?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filePricing?: InputMaybe<Array<InputMaybe<FilePricingInput>>>;
  forceDisableFilesSales?: InputMaybe<Scalars['Boolean']['input']>;
  forceDisablePrintsSales?: InputMaybe<Scalars['Boolean']['input']>;
  forceDisableProductsSales?: InputMaybe<Scalars['Boolean']['input']>;
  freePackageId?: InputMaybe<Scalars['ID']['input']>;
  freeThumbSize?: InputMaybe<Scalars['Int']['input']>;
  freeThumbWatermarkConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  internalCode?: InputMaybe<Scalars['String']['input']>;
  lookBookConfig?: InputMaybe<SessionLookBookConfigInput>;
  lookBookEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Array<InputMaybe<PrivateSessionMessageInput>>>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  organizationClientId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  packages?: InputMaybe<Array<InputMaybe<UpdateProductPackage>>>;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  priceToAddToFirstPrint?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printsPricingListId?: InputMaybe<Scalars['ID']['input']>;
  productsSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retouchLevels?: InputMaybe<Array<InputMaybe<RetouchLevelInput>>>;
  retouchLevelsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  salesMode?: InputMaybe<PrivateSessionSalesMode>;
  scheduleEventId?: InputMaybe<Scalars['ID']['input']>;
  sellFiles?: InputMaybe<Scalars['Boolean']['input']>;
  sellPackages?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrints?: InputMaybe<Scalars['Boolean']['input']>;
  sellProducts?: InputMaybe<Scalars['Boolean']['input']>;
  settlements?: InputMaybe<PrivateSessionSettlementsInput>;
  showFileNames?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  skipAddToFirstPrintIfFileBought?: InputMaybe<Scalars['Boolean']['input']>;
  skipFavoriteInFileMode?: InputMaybe<Scalars['Boolean']['input']>;
  soldFilesWatermarkConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  soldFilesWatermarked?: InputMaybe<Scalars['Boolean']['input']>;
  soldWatermarkSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  usePromoCodes?: InputMaybe<Scalars['Boolean']['input']>;
  watermarkConfig?: InputMaybe<ProtectionWatermarkConfigInput>;
  watermarkEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrivateSessionMessage = {
  __typename?: 'PrivateSessionMessage';
  context: Maybe<PrivateSessionMessageContext>;
  message: Maybe<Array<Maybe<CustomLabel>>>;
};

export enum PrivateSessionMessageContext {
  Order = 'Order',
  Welcome = 'Welcome',
}

export type PrivateSessionMessageInput = {
  context: PrivateSessionMessageContext;
  message: Array<InputMaybe<CustomLabelInput>>;
};

export enum PrivateSessionSalesMode {
  Ambiguous = 'Ambiguous',
  Files = 'Files',
  Packages = 'Packages',
}

export type PrivateSessionSettlements = {
  __typename?: 'PrivateSessionSettlements';
  basicSessionPrice: Maybe<BasicSessionPrice>;
  onlinePayments: Maybe<OnlinePayments>;
  requiredPrePayment: Maybe<RequiredPrePayment>;
};

export type PrivateSessionSettlementsInput = {
  basicSessionPrice?: InputMaybe<BasicSessionPriceInput>;
  onlinePayments?: InputMaybe<OnlinePaymentsInput>;
  prePaidOption?: InputMaybe<PrepaidOptions>;
  requiredPrePayment?: InputMaybe<RequiredPrePaymentInput>;
};

export type PrivateSessionSortInput = {
  order: Scalars['Int']['input'];
  privateSessionGroupId: Scalars['String']['input'];
};

export type PrivateSessionUpdateInput = {
  acceptOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  addPrintFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addToFirstPrintPrice?: InputMaybe<Scalars['Boolean']['input']>;
  allowComments?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  autoSellConfig?: InputMaybe<PrivateSessionAutoSellConfigInput>;
  autoSellEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clientPermissionsConfig?: InputMaybe<Scalars['String']['input']>;
  configTemplateId?: InputMaybe<Scalars['ID']['input']>;
  context?: InputMaybe<PrivateSessionContext>;
  cover?: InputMaybe<CoverUpdateDetails>;
  deadline?: InputMaybe<Scalars['Int']['input']>;
  deadlineScenario?: InputMaybe<DeadlineScenario>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  digitalOrderForcePhone?: InputMaybe<Scalars['Boolean']['input']>;
  enableFreeThumb?: InputMaybe<Scalars['Boolean']['input']>;
  excludedProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filePricing?: InputMaybe<Array<InputMaybe<FilePricingInput>>>;
  forceDisableFilesSales?: InputMaybe<Scalars['Boolean']['input']>;
  forceDisablePrintsSales?: InputMaybe<Scalars['Boolean']['input']>;
  forceDisableProductsSales?: InputMaybe<Scalars['Boolean']['input']>;
  freePackageId?: InputMaybe<Scalars['ID']['input']>;
  freeThumbSize?: InputMaybe<Scalars['Int']['input']>;
  freeThumbWatermarkConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  internalCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lookBookConfig?: InputMaybe<SessionLookBookConfigInput>;
  lookBookEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Array<InputMaybe<PrivateSessionMessageInput>>>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  organizationClientId?: InputMaybe<Scalars['ID']['input']>;
  packages?: InputMaybe<Array<InputMaybe<UpdateProductPackage>>>;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  priceToAddToFirstPrint?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printsPricingListId?: InputMaybe<Scalars['ID']['input']>;
  productsSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retouchLevels?: InputMaybe<Array<InputMaybe<RetouchLevelInput>>>;
  retouchLevelsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  salesMode?: InputMaybe<PrivateSessionSalesMode>;
  sellFiles?: InputMaybe<Scalars['Boolean']['input']>;
  sellPackages?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrints?: InputMaybe<Scalars['Boolean']['input']>;
  sellProducts?: InputMaybe<Scalars['Boolean']['input']>;
  settlements?: InputMaybe<PrivateSessionSettlementsInput>;
  showFileNames?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  skipAddToFirstPrintIfFileBought?: InputMaybe<Scalars['Boolean']['input']>;
  skipFavoriteInFileMode?: InputMaybe<Scalars['Boolean']['input']>;
  soldFilesWatermarkConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  soldFilesWatermarked?: InputMaybe<Scalars['Boolean']['input']>;
  soldWatermarkSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  usePromoCodes?: InputMaybe<Scalars['Boolean']['input']>;
  visualPersonalization?: InputMaybe<Scalars['String']['input']>;
  watermarkConfig?: InputMaybe<ProtectionWatermarkConfigInput>;
  watermarkEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Product = {
  __typename?: 'Product';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasTaxConfig: Maybe<Scalars['Boolean']['output']>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taxConfig: Maybe<ProductTaxConfig>;
  type: Maybe<ProductType>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  config: Maybe<Scalars['String']['output']>;
  customName: Maybe<Array<Maybe<CustomLabel>>>;
  icon: Maybe<Scalars['String']['output']>;
  mode: Maybe<ProductMode>;
  productId: Maybe<Scalars['String']['output']>;
  productInPackageId: Maybe<Scalars['String']['output']>;
  qty: Maybe<Scalars['Int']['output']>;
};

export type ProductForDisplay = {
  __typename?: 'ProductForDisplay';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<ProductType>;
};

export enum ProductMode {
  AllImagesFromPackage = 'AllImagesFromPackage',
  AnyImages = 'AnyImages',
  AnyImagesFromPackage = 'AnyImagesFromPackage',
}

export type ProductPackage = {
  __typename?: 'ProductPackage';
  allowMultiple: Maybe<Scalars['Boolean']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printAndFileConfig: Maybe<Array<Maybe<PrintAndFileConfig>>>;
  productConfig: Maybe<Array<Maybe<ProductConfig>>>;
  productPackageId: Maybe<Scalars['ID']['output']>;
};

export type ProductTaxConfig = {
  __typename?: 'ProductTaxConfig';
  label: Maybe<Scalars['String']['output']>;
  vatRate: Maybe<Scalars['Int']['output']>;
};

export type ProductTaxConfigInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductToProductRelation = {
  __typename?: 'ProductToProductRelation';
  id: Maybe<Scalars['String']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['String']['output']>;
  productId: Maybe<Scalars['String']['output']>;
  type: Maybe<ProductToProductRelationType>;
  value: Maybe<Scalars['String']['output']>;
};

export enum ProductToProductRelationType {
  Attribute = 'Attribute',
  Lab = 'Lab',
  Option = 'Option',
  Product = 'Product',
}

export enum ProductType {
  Album = 'Album',
  AlbumSet2plusOne = 'AlbumSet2plusOne',
  AlbumSetTriple = 'AlbumSetTriple',
  AlbumWithAcrylicPicture = 'AlbumWithAcrylicPicture',
  Book = 'Book',
  Calendar = 'Calendar',
  Canvas = 'Canvas',
  EconomicTwoPageTablo = 'EconomicTwoPageTablo',
  FatPrint = 'FatPrint',
  Frame = 'Frame',
  IdentityPhoto = 'IdentityPhoto',
  MagnetSticker = 'MagnetSticker',
  Mug = 'Mug',
  Other = 'Other',
  Prints = 'Prints',
  Tablo = 'Tablo',
  Tambour = 'Tambour',
  Triplex = 'Triplex',
  Wallart = 'Wallart',
  ZalamoCalendar = 'ZalamoCalendar',
  ZalamoEconomicTwoPageTablo = 'ZalamoEconomicTwoPageTablo',
  ZalamoMagnet = 'ZalamoMagnet',
  ZalamoPremiumTwoPageTablo = 'ZalamoPremiumTwoPageTablo',
}

export enum PromoCodeError {
  AlreadyUsed = 'AlreadyUsed',
  Expired = 'Expired',
  NotExisting = 'NotExisting',
}

export type ProtectionWatermarkConfig = {
  __typename?: 'ProtectionWatermarkConfig';
  aiLevel: Maybe<Scalars['String']['output']>;
  customConfig: Maybe<SoldFilesUniversalWatermarkConfig>;
  fileName: Maybe<Scalars['ID']['output']>;
  linesOpacity: Maybe<Scalars['Float']['output']>;
  mode: ProtectionWatermarkMode;
  showLines: Maybe<Scalars['Boolean']['output']>;
  source: Maybe<ProtectionWatermarkSource>;
  text: Maybe<Array<Maybe<CustomLabel>>>;
  textOpacity: Maybe<Scalars['Float']['output']>;
};

export type ProtectionWatermarkConfigInput = {
  aiLevel?: InputMaybe<Scalars['String']['input']>;
  customConfig?: InputMaybe<SoldFilesUniversalWatermarkConfigInput>;
  fileName: Scalars['ID']['input'];
  linesOpacity: Scalars['Float']['input'];
  mode: ProtectionWatermarkMode;
  showLines: Scalars['Boolean']['input'];
  source: ProtectionWatermarkSource;
  text: Array<InputMaybe<CustomLabelInput>>;
  textOpacity: Scalars['Float']['input'];
};

export enum ProtectionWatermarkMode {
  Custom = 'Custom',
  Multi = 'Multi',
  Single = 'Single',
}

export enum ProtectionWatermarkSource {
  AntiAi = 'AntiAi',
  Image = 'Image',
  Text = 'Text',
}

export type PublicSessionAuthDetails = {
  __typename?: 'PublicSessionAuthDetails';
  PublicSessionAuthDetailsId: Maybe<Scalars['ID']['output']>;
  authMode: Maybe<PublicSessionAuthMode>;
  deadline: Maybe<Scalars['Int']['output']>;
  horizontalLogo: Maybe<Scalars['ID']['output']>;
  inAppOnly: Maybe<Scalars['Boolean']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  organizationId: Maybe<Scalars['ID']['output']>;
  personAccessRequired: Scalars['Boolean']['output'];
  squareLogo: Maybe<Scalars['ID']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export enum PublicSessionAuthMode {
  NoAuth = 'NoAuth',
  Password = 'Password',
}

export enum PublicSessionContext {
  CompanyEvent = 'CompanyEvent',
  CompetitionBasketball = 'CompetitionBasketball',
  CompetitionBikeRiding = 'CompetitionBikeRiding',
  CompetitionCarRace = 'CompetitionCarRace',
  CompetitionDance = 'CompetitionDance',
  CompetitionFootball = 'CompetitionFootball',
  CompetitionHorseRiding = 'CompetitionHorseRiding',
  CompetitionMotoBike = 'CompetitionMotoBike',
  CompetitionRunning = 'CompetitionRunning',
  KindergartenSession = 'KindergartenSession',
  None = 'None',
  Prom = 'Prom',
  ReligionEventBaptism = 'ReligionEventBaptism',
  ReligionEventFirstCommunion = 'ReligionEventFirstCommunion',
  ReligionEventWedding = 'ReligionEventWedding',
  SchoolSession = 'SchoolSession',
  ShowCats = 'ShowCats',
  ShowDogs = 'ShowDogs',
  ShowHorses = 'ShowHorses',
}

export type PublicSessionForDisplay = {
  __typename?: 'PublicSessionForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  authMode: Maybe<PublicSessionAuthMode>;
  autoSellConfig: Maybe<AutoSellConfig>;
  autoSellEnabled: Maybe<Scalars['Boolean']['output']>;
  availableProducts: Maybe<Array<Maybe<ProductForDisplay>>>;
  calendarPrices: Maybe<Array<Maybe<CalendarForDisplay>>>;
  clientPermissionsConfig: Maybe<Scalars['String']['output']>;
  context: Maybe<PublicSessionContext>;
  cover: Maybe<CoverSetup>;
  created: Maybe<Scalars['Int']['output']>;
  customDigitalFileName: Maybe<Array<Maybe<CustomLabel>>>;
  deliveryMethods: Maybe<Array<Maybe<DeliveryMethodForDisplay>>>;
  digitalOrderForcePhone: Maybe<Scalars['Boolean']['output']>;
  disableImageZoom: Maybe<Scalars['Boolean']['output']>;
  doNotAddPriceOfFirstPrint: Maybe<Scalars['Boolean']['output']>;
  eSkarbonka: Maybe<PublicSessionOrganizationEskarbonkaProgress>;
  enableFreeThumb: Maybe<Scalars['Boolean']['output']>;
  enableKeywordSearch: Maybe<Scalars['Boolean']['output']>;
  enableMinimalOrderValue: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  frame: Maybe<Product>;
  freeDownloadAllAvailable: Maybe<Scalars['Boolean']['output']>;
  freeDownloadAvailable: Maybe<Scalars['Boolean']['output']>;
  freePackageId: Maybe<Scalars['ID']['output']>;
  freeThumbSize: Maybe<Scalars['Int']['output']>;
  groupImagesByPeople: Maybe<Scalars['Boolean']['output']>;
  groupImagesByPeopleType: Maybe<GroupImagesByPeopleTypeForDisplay>;
  groups: Maybe<Array<Maybe<PublicSessionGroupForDisplay>>>;
  horizontalLogo: Maybe<Scalars['ID']['output']>;
  invoicingEnabled: Maybe<Scalars['Boolean']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  lookBookConfig: Maybe<SessionLookBookConfigForDisplay>;
  lookBookEnabled: Maybe<Scalars['Boolean']['output']>;
  magnetPrices: Maybe<Array<Maybe<MagnetForDisplay>>>;
  messages: Maybe<Array<Maybe<PublicSessionMessage>>>;
  minimalOrderValue: Maybe<Array<Maybe<PriceConfig>>>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  organizationId: Maybe<Scalars['ID']['output']>;
  ownPrintsPricing: Maybe<PrintsPricingListForDisplay>;
  packages: Maybe<Array<Maybe<ProductPackage>>>;
  people: Maybe<Array<Maybe<PersonForPublicSession>>>;
  picturesWithPeople: Maybe<Array<Maybe<PhotoWithPeople>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printOwnPhotosEnabled: Maybe<Scalars['Boolean']['output']>;
  printsPricing: Maybe<PrintsPricingListForDisplay>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  promoPrintFlyerId: Maybe<Scalars['ID']['output']>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  retouchLevels: Maybe<Array<Maybe<RetouchLevel>>>;
  retouchLevelsEnabled: Maybe<Scalars['Boolean']['output']>;
  sellCalendar: Maybe<Scalars['Boolean']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellMagnet: Maybe<Scalars['Boolean']['output']>;
  sellPackages: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  sellTablo: Maybe<Scalars['Boolean']['output']>;
  showFileNames: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  squareLogo: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  tabloList: Maybe<Array<Maybe<TabloForDisplay>>>;
  tosId: Maybe<Scalars['ID']['output']>;
  useCustomDigitalFileName: Maybe<Scalars['Boolean']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  usePromoCodes: Maybe<Scalars['Boolean']['output']>;
  visualPersonalization: Maybe<Scalars['String']['output']>;
};

export type PublicSessionGroupForDisplay = {
  __typename?: 'PublicSessionGroupForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  addPrintFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addToFirstPrintPrice: Maybe<Scalars['Boolean']['output']>;
  customFilesPricing: Maybe<Scalars['Boolean']['output']>;
  customPrintsPricing: Maybe<Scalars['Boolean']['output']>;
  customProductsConfig: Maybe<Scalars['Boolean']['output']>;
  disableLookBook: Maybe<Scalars['Boolean']['output']>;
  disableZalamoPrint: Maybe<Scalars['Boolean']['output']>;
  excludedProducts: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filePricing: Maybe<Array<Maybe<FilePricing>>>;
  identityPhotoPaperId: Maybe<Scalars['ID']['output']>;
  identityPhotoPassDigital: Maybe<Scalars['Boolean']['output']>;
  images: Maybe<Array<Maybe<ImageForDisplay>>>;
  individualSellSettings: Maybe<Scalars['Boolean']['output']>;
  isIdentityPhotoOnly: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  order: Maybe<Scalars['Int']['output']>;
  photoGroupId: Maybe<Scalars['String']['output']>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  priceToAddToFirstPrint: Maybe<Array<Maybe<PriceConfig>>>;
  printsPricing: Maybe<PrintsPricingListForDisplay>;
  productsSort: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publicSessionGroupId: Maybe<Scalars['String']['output']>;
  publicSessionId: Maybe<Scalars['String']['output']>;
  sellFiles: Maybe<Scalars['Boolean']['output']>;
  sellPrints: Maybe<Scalars['Boolean']['output']>;
  sellProducts: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  skipAddToFirstPrintIfFileBought: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  useFilePricingToCalculatePriceToAddToEveryFileInPrint: Maybe<
    Scalars['Boolean']['output']
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
};

export type PublicSessionMessage = {
  __typename?: 'PublicSessionMessage';
  context: Maybe<PublicSessionMessageContext>;
  message: Maybe<Array<Maybe<CustomLabel>>>;
};

export enum PublicSessionMessageContext {
  Order = 'Order',
  Welcome = 'Welcome',
}

export type PublicSessionMessageInput = {
  context: PublicSessionMessageContext;
  message: Array<InputMaybe<CustomLabelInput>>;
};

export type PublicSessionOrganizationEskarbonkaProgress = {
  __typename?: 'PublicSessionOrganizationEskarbonkaProgress';
  currentAmount: Maybe<Scalars['Float']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  limitAmount: Maybe<Scalars['Float']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  publicLinkHash: Maybe<Scalars['ID']['output']>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
};

export type PublicSessionOrganizationEskarbonkaPublicView = {
  __typename?: 'PublicSessionOrganizationEskarbonkaPublicView';
  currentAmount: Maybe<Scalars['Float']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  limitAmount: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  publicSessionOrganizationId: Maybe<Scalars['ID']['output']>;
};

export type Query = {
  __typename?: 'Query';
  generateGoogleCalendarAuthLink: Maybe<Scalars['String']['output']>;
  getAllMineBookingSessionCategories: Maybe<
    Array<Maybe<BookingSessionCategory>>
  >;
  getAllMinePackages: Maybe<Array<Maybe<PhotoPackage>>>;
  getAllMineSessionCategories: Maybe<Array<Maybe<SessionCategory>>>;
  getAllScheduleEventsForUser: Maybe<Array<Maybe<ScheduleEvent>>>;
  getBookingConfig: Maybe<BookingConfig>;
  getBookingPhotoAdditions: Maybe<Array<Maybe<BookingPackageAddition>>>;
  getBookingPreviewURL: Maybe<Scalars['String']['output']>;
  getMineOldPrivateSessionConfigTemplates: Maybe<
    Array<Maybe<OldPrivateSessionConfigTemplate>>
  >;
  getMineWorkingHours: Maybe<Array<Maybe<WorkingHour>>>;
  getOrganizationClientIdForScheduleEvent: Maybe<Scalars['String']['output']>;
  getScheduleEventOldTemplateId: Maybe<Scalars['String']['output']>;
  mock: Maybe<Scalars['String']['output']>;
};

export type QueryGetAllMineBookingSessionCategoriesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetAllMinePackagesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetAllMineSessionCategoriesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetAllScheduleEventsForUserArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetBookingConfigArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetBookingPhotoAdditionsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetBookingPreviewUrlArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationClientIdForScheduleEventArgs = {
  organizationId: Scalars['ID']['input'];
  scheduleEventId: Scalars['ID']['input'];
};

export type QueryGetScheduleEventOldTemplateIdArgs = {
  scheduleEventId: Scalars['ID']['input'];
};

export type QuickLink = {
  __typename?: 'QuickLink';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  link: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quickLinkId: Maybe<Scalars['ID']['output']>;
};

export type RecurConfig = {
  __typename?: 'RecurConfig';
  dayOfAWeekRepeat: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  endsAtDate: Maybe<Scalars['String']['output']>;
  endsAtType: Maybe<RecurEndType>;
  excluded: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  monthRecur: Maybe<MonthRecurConfig>;
  unit: Maybe<RecurUnitTypes>;
  value: Maybe<Scalars['Int']['output']>;
};

export type RecurConfigInput = {
  dayOfAWeekRepeat?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endsAtDate?: InputMaybe<Scalars['String']['input']>;
  endsAtType?: InputMaybe<RecurEndType>;
  excluded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  monthRecur?: InputMaybe<MonthRecurConfig>;
  unit?: InputMaybe<RecurUnitTypes>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export enum RecurEndType {
  Exact = 'exact',
  Never = 'never',
}

export enum RecurUnitTypes {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year',
}

export type RequiredPrePayment = {
  __typename?: 'RequiredPrePayment';
  alreadyPaid: Maybe<Scalars['Boolean']['output']>;
  isSet: Maybe<Scalars['Boolean']['output']>;
  prePaidOption: Maybe<PrepaidOptions>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
};

export type RequiredPrePaymentInput = {
  alreadyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  prePaidOption?: InputMaybe<PrepaidOptions>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
};

export type RetouchLevel = {
  __typename?: 'RetouchLevel';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  retouchLevelId: Maybe<Scalars['ID']['output']>;
};

export type RetouchLevelInput = {
  label: Array<InputMaybe<CustomLabelInput>>;
  price: Array<InputMaybe<PriceConfigInput>>;
  retouchLevelId: Scalars['ID']['input'];
};

export type SampleSupplierOrderConfig = {
  __typename?: 'SampleSupplierOrderConfig';
  hash: Maybe<Scalars['String']['output']>;
  orderNumber: Maybe<Scalars['Int']['output']>;
  productType: Maybe<ProductType>;
  status: Maybe<Scalars['Boolean']['output']>;
  supplierId: Scalars['ID']['output'];
};

export type SampleSupplierOrderInput = {
  file: Scalars['ID']['input'];
  fileHeight: Scalars['Int']['input'];
  fileWidth: Scalars['Int']['input'];
};

export type SamplesSupplierOrderInput = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientFirstName?: InputMaybe<Scalars['String']['input']>;
  clientLastName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyFlatNumber?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatId?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSameAsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryBuildingNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryCity?: InputMaybe<Scalars['String']['input']>;
  deliveryFlatNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  deliveryZipCode?: InputMaybe<Scalars['String']['input']>;
  lockerAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lockerId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  productType?: InputMaybe<ProductType>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDataProcessingAgreementDraftInput = {
  businessType?: InputMaybe<DataProcessingAgreementBusinessType>;
  dataAgreementDetails?: InputMaybe<DataAgreementDetailsInput>;
  representatives: Array<
    InputMaybe<DataProcessingAgreementRepresentativeInput>
  >;
};

export type ScheduleEvent = {
  __typename?: 'ScheduleEvent';
  afterBuffer: Maybe<Scalars['Int']['output']>;
  beforeBuffer: Maybe<Scalars['Int']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  created: Maybe<Scalars['Int']['output']>;
  endsAt: Maybe<Scalars['Int']['output']>;
  gdprSeen: Maybe<Scalars['Boolean']['output']>;
  hasNewPricing: Maybe<Scalars['Boolean']['output']>;
  isRecur: Maybe<Scalars['Boolean']['output']>;
  locksDayAfter: Maybe<Scalars['Boolean']['output']>;
  newSessionId: Maybe<Scalars['ID']['output']>;
  oldClientId: Maybe<Scalars['ID']['output']>;
  organizationClientId: Maybe<Scalars['ID']['output']>;
  packages: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  postScheduleMessage: Maybe<Scalars['String']['output']>;
  prepaidAmount: Maybe<Scalars['Float']['output']>;
  prepaidDeadline: Maybe<Scalars['Int']['output']>;
  prepaidPaid: Maybe<Scalars['Boolean']['output']>;
  questionnaireAnswers: Maybe<Scalars['String']['output']>;
  questionnaireSent: Maybe<Scalars['Boolean']['output']>;
  recurConfig: Maybe<RecurConfig>;
  ref: Maybe<Scalars['String']['output']>;
  scheduleEventId: Maybe<Scalars['String']['output']>;
  snapshot: Maybe<Scalars['String']['output']>;
  startsAt: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<ScheduleEventType>;
  userId: Maybe<Scalars['Int']['output']>;
};

export type ScheduleEventInput = {
  afterBuffer?: InputMaybe<Scalars['Int']['input']>;
  beforeBuffer?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['Int']['input']>;
  endsAt?: InputMaybe<Scalars['Int']['input']>;
  hasNewPricing?: InputMaybe<Scalars['Boolean']['input']>;
  isRecur?: InputMaybe<Scalars['Boolean']['input']>;
  newSessionId?: InputMaybe<Scalars['ID']['input']>;
  oldClientId?: InputMaybe<Scalars['ID']['input']>;
  organizationClientId?: InputMaybe<Scalars['ID']['input']>;
  packages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postScheduleMessage?: InputMaybe<Scalars['String']['input']>;
  prepaidAmount?: InputMaybe<Scalars['Float']['input']>;
  prepaidDeadline?: InputMaybe<Scalars['Int']['input']>;
  prepaidPaid?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireSent?: InputMaybe<Scalars['Boolean']['input']>;
  recurConfig?: InputMaybe<RecurConfigInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ScheduleEventType>;
};

export type ScheduleEventInsertInput = {
  afterBuffer?: InputMaybe<Scalars['Int']['input']>;
  beforeBuffer?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['Int']['input']>;
  endsAt?: InputMaybe<Scalars['Int']['input']>;
  hasNewPricing?: InputMaybe<Scalars['Boolean']['input']>;
  isRecur?: InputMaybe<Scalars['Boolean']['input']>;
  organizationClientId?: InputMaybe<Scalars['ID']['input']>;
  packages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postScheduleMessage?: InputMaybe<Scalars['String']['input']>;
  prepaidAmount?: InputMaybe<Scalars['Float']['input']>;
  prepaidDeadline?: InputMaybe<Scalars['Int']['input']>;
  prepaidPaid?: InputMaybe<Scalars['Boolean']['input']>;
  recurConfig?: InputMaybe<RecurConfigInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ScheduleEventType>;
};

export enum ScheduleEventType {
  Break = 'break',
  Event = 'event',
  External = 'external',
  Prereservation = 'prereservation',
  Reservation = 'reservation',
  Slot = 'slot',
}

export type SessionAlbumLookBookConfig = {
  __typename?: 'SessionAlbumLookBookConfig';
  commission: Maybe<Scalars['Int']['output']>;
  excludedMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  excludedSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionAlbumLookBookConfigForDisplay = {
  __typename?: 'SessionAlbumLookBookConfigForDisplay';
  commission: Maybe<Scalars['Int']['output']>;
  excludedMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  excludedSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionAlbumLookBookConfigInput = {
  commission?: InputMaybe<Scalars['Int']['input']>;
  excludedMaterials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedSizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  labIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rounding?: InputMaybe<LookBookPriceRounding>;
};

export type SessionCategory = {
  __typename?: 'SessionCategory';
  fileName: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['ID']['output']>;
  sessionCategoryId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type SessionLookBookConfig = {
  __typename?: 'SessionLookBookConfig';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  personalization: Maybe<DecorationPreConfig>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  printFramesConfig: Maybe<SessionPrintFramesLookBookConfig>;
  sellAlbums: Maybe<Scalars['Boolean']['output']>;
  sellPrintFrames: Maybe<Scalars['Boolean']['output']>;
  sellTambour: Maybe<Scalars['Boolean']['output']>;
  sellTriplex: Maybe<Scalars['Boolean']['output']>;
  sellWallDecor: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tambourConfig: Maybe<SessionWallDecorLookBookConfig>;
  triplexConfig: Maybe<SessionTriplexLookBookConfig>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  wallDecorConfig: Maybe<SessionWallDecorLookBookConfig>;
};

export type SessionLookBookConfigForDisplay = {
  __typename?: 'SessionLookBookConfigForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  decorationPreConfig: Maybe<DecorationPreConfigForClient>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  printFramesConfig: Maybe<SessionPrintFramesLookBookConfigForDisplay>;
  sellAlbums: Maybe<Scalars['Boolean']['output']>;
  sellPrintFrames: Maybe<Scalars['Boolean']['output']>;
  sellTambour: Maybe<Scalars['Boolean']['output']>;
  sellTriplex: Maybe<Scalars['Boolean']['output']>;
  sellWallDecor: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tambourConfig: Maybe<SessionWallDecorLookBookConfigForDisplay>;
  triplexConfig: Maybe<SessionTriplexLookBookConfigForDisplay>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  wallDecorConfig: Maybe<SessionWallDecorLookBookConfigForDisplay>;
};

export type SessionLookBookConfigInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  albumConfig?: InputMaybe<SessionAlbumLookBookConfigInput>;
  personalization?: InputMaybe<DecorationPreConfigInput>;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  printFramesConfig?: InputMaybe<SessionPrintFramesLookBookConfigInput>;
  sellAlbums?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrintFrames?: InputMaybe<Scalars['Boolean']['input']>;
  sellTambour?: InputMaybe<Scalars['Boolean']['input']>;
  sellTriplex?: InputMaybe<Scalars['Boolean']['input']>;
  sellWallDecor?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  tambourConfig?: InputMaybe<SessionWallDecorLookBookConfigInput>;
  triplexConfig?: InputMaybe<SessionTriplexLookBookConfigInput>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  wallDecorConfig?: InputMaybe<SessionWallDecorLookBookConfigInput>;
};

export enum SessionOccasion {
  Baphthism = 'Baphthism',
  Birthday = 'Birthday',
  FirstBirthday = 'FirstBirthday',
  FirstCommunion = 'FirstCommunion',
  Newborn = 'Newborn',
  Wedding = 'Wedding',
}

export type SessionPrintFrameConfig = {
  __typename?: 'SessionPrintFrameConfig';
  color: Maybe<Scalars['String']['output']>;
  format: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  sessionPrintFrameConfigId: Maybe<Scalars['ID']['output']>;
  shape: Maybe<Scalars['String']['output']>;
};

export type SessionPrintFramesLookBookConfig = {
  __typename?: 'SessionPrintFramesLookBookConfig';
  availableColors: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  commission: Maybe<Scalars['Int']['output']>;
  limitColors: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionPrintFramesLookBookConfigForDisplay = {
  __typename?: 'SessionPrintFramesLookBookConfigForDisplay';
  availableColors: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  limitColors: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionPrintFramesLookBookConfigInput = {
  availableColors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  commission?: InputMaybe<Scalars['Int']['input']>;
  limitColors?: InputMaybe<Scalars['Boolean']['input']>;
  rounding?: InputMaybe<LookBookPriceRounding>;
};

export type SessionTriplexLookBookConfig = {
  __typename?: 'SessionTriplexLookBookConfig';
  availableMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  commission: Maybe<Scalars['Int']['output']>;
  labIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  limitMaterials: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionTriplexLookBookConfigForDisplay = {
  __typename?: 'SessionTriplexLookBookConfigForDisplay';
  availableMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labId: Maybe<Scalars['String']['output']>;
  limitMaterials: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionTriplexLookBookConfigInput = {
  availableMaterials?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  commission?: InputMaybe<Scalars['Int']['input']>;
  labIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limitMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  rounding?: InputMaybe<LookBookPriceRounding>;
};

export type SessionWallDecorLookBookConfig = {
  __typename?: 'SessionWallDecorLookBookConfig';
  commission: Maybe<Scalars['Int']['output']>;
  disablePersonalizationOnSinglePhoto: Maybe<Scalars['Boolean']['output']>;
  labIds: Maybe<Scalars['ID']['output']>;
  preConfig: Maybe<Scalars['String']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionWallDecorLookBookConfigForDisplay = {
  __typename?: 'SessionWallDecorLookBookConfigForDisplay';
  disablePersonalizationOnSinglePhoto: Maybe<Scalars['Boolean']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  preConfig: Maybe<Scalars['String']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionWallDecorLookBookConfigInput = {
  commission?: InputMaybe<Scalars['Int']['input']>;
  disablePersonalizationOnSinglePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  labIds?: InputMaybe<Scalars['ID']['input']>;
  preConfig?: InputMaybe<Scalars['String']['input']>;
  rounding?: InputMaybe<LookBookPriceRounding>;
};

export type SinglePhoto = {
  __typename?: 'SinglePhoto';
  created: Maybe<Scalars['Int']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  fileUploaded: Maybe<Scalars['Boolean']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  isRaw: Maybe<Scalars['Boolean']['output']>;
  isRetouched: Maybe<Scalars['Boolean']['output']>;
  localPath: Maybe<Scalars['String']['output']>;
  originalHeight: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  originalWidth: Maybe<Scalars['Int']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  shootDate: Maybe<Scalars['Int']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type SoldFilesUniversalWatermarkConfig = {
  __typename?: 'SoldFilesUniversalWatermarkConfig';
  horizontal: Maybe<SoldFilesWatermarkConfig>;
  soldFilesUniversalWatermarkConfigId: Maybe<Scalars['ID']['output']>;
  vertical: Maybe<SoldFilesWatermarkConfig>;
};

export type SoldFilesUniversalWatermarkConfigInput = {
  horizontal: SoldFilesWatermarkConfigInput;
  soldFilesUniversalWatermarkConfigId?: InputMaybe<Scalars['ID']['input']>;
  vertical: SoldFilesWatermarkConfigInput;
};

export type SoldFilesWatermarkConfig = {
  __typename?: 'SoldFilesWatermarkConfig';
  alpha: Maybe<Scalars['Float']['output']>;
  config: Maybe<SoldFilesWatermarkConfigPosition>;
  file: Maybe<Scalars['String']['output']>;
  soldFilesWatermarkConfigId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesWatermarkConfigInput = {
  alpha: Scalars['Float']['input'];
  config: SoldFilesWatermarkConfigPositionInput;
  file: Scalars['String']['input'];
  soldFilesWatermarkConfigId: Scalars['ID']['input'];
};

export type SoldFilesWatermarkConfigPosition = {
  __typename?: 'SoldFilesWatermarkConfigPosition';
  left: Maybe<Scalars['Float']['output']>;
  soldFilesWatermarkConfigPositionId: Maybe<Scalars['ID']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type SoldFilesWatermarkConfigPositionInput = {
  left: Scalars['Float']['input'];
  soldFilesWatermarkConfigPositionId: Scalars['ID']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type SortInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  photoInGroupId: Scalars['ID']['input'];
};

export type StartDataProcessingAgreementSigningInput = {
  businessType: DataProcessingAgreementBusinessType;
  dataAgreementDetails: DataAgreementDetailsInput;
  representatives: Array<
    InputMaybe<DataProcessingAgreementRepresentativeInput>
  >;
};

export type StatusList = {
  __typename?: 'StatusList';
  done: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<CustomLabel>;
  order: Maybe<Scalars['Int']['output']>;
  statusId: Maybe<Scalars['ID']['output']>;
};

export type StepPricing = {
  __typename?: 'StepPricing';
  firstStep: Maybe<Scalars['Int']['output']>;
  isFirstStepFree: Maybe<Scalars['Boolean']['output']>;
  lastStepPrice: Maybe<Array<Maybe<PriceConfig>>>;
  mode: Maybe<StepPricingMode>;
  steps: Maybe<Array<Maybe<PriceStep>>>;
};

export type StepPricingInput = {
  firstStep: Scalars['Int']['input'];
  isFirstStepFree: Scalars['Boolean']['input'];
  lastStepPrice: Array<InputMaybe<PriceConfigInput>>;
  mode: StepPricingMode;
  steps: Array<InputMaybe<PriceStepInput>>;
};

export enum StepPricingMode {
  Bundles = 'Bundles',
  ForAll = 'ForAll',
  ForOverTreshold = 'ForOverTreshold',
  None = 'None',
}

export type SubdomainUpdateResult = {
  __typename?: 'SubdomainUpdateResult';
  organization: Maybe<Organization>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  mockSub: Maybe<Scalars['ID']['output']>;
  scheduleEventAdded: Maybe<ScheduleEvent>;
  scheduleEventUpdated: Maybe<ScheduleEvent>;
};

export type SubscriptionScheduleEventAddedArgs = {
  organizationId: Scalars['ID']['input'];
};

export type SubscriptionScheduleEventUpdatedArgs = {
  organizationId: Scalars['ID']['input'];
};

export type SupplierOrdersConfig = {
  __typename?: 'SupplierOrdersConfig';
  file: Maybe<Scalars['ID']['output']>;
  suppliers: Maybe<Array<Maybe<SampleSupplierOrderConfig>>>;
};

export type SupplierPrintsImportConfig = {
  count: Scalars['Int']['input'];
  hasFrame: Scalars['Boolean']['input'];
  printFormatId: Scalars['ID']['input'];
  printPaperId: Scalars['ID']['input'];
  targetFakeGroupId: Scalars['ID']['input'];
};

export type TabloForDisplay = {
  __typename?: 'TabloForDisplay';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  size: Maybe<TabloSize>;
  tabloForDisplayId: Maybe<Scalars['ID']['output']>;
};

export enum TabloSize {
  S15x20 = 's15x20',
  S20x15 = 's20x15',
  S20x30 = 's20x30',
}

export type TagsList = {
  __typename?: 'TagsList';
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TriplexRenderPreviewConfig = {
  __typename?: 'TriplexRenderPreviewConfig';
  accessToken: Maybe<Scalars['ID']['output']>;
  fileName: Maybe<Scalars['ID']['output']>;
  images: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  triplexRenderPreviewConfigId: Maybe<Scalars['ID']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type TriplexRenderPreviewConfigInput = {
  fileName?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFilesConfig = {
  count: Scalars['Int']['input'];
  isFull: Scalars['Boolean']['input'];
  size: Scalars['Int']['input'];
};

export type UpdatePrintAndFileConfig = {
  filesConfig?: InputMaybe<Array<InputMaybe<UpdateFilesConfig>>>;
  forcedImage?: InputMaybe<ForcedImageConfigUpdate>;
  groups: Array<InputMaybe<Scalars['String']['input']>>;
  mode?: InputMaybe<FilesAndPrintsPackageType>;
  printAndFileConfigId?: InputMaybe<Scalars['ID']['input']>;
  printsCount?: InputMaybe<Array<InputMaybe<UpdatePrintsCount>>>;
};

export type UpdatePrintsCount = {
  count: Scalars['Int']['input'];
  printFormatId: Scalars['String']['input'];
  printPaperId: Scalars['String']['input'];
};

export type UpdateProductConfig = {
  config: Scalars['String']['input'];
  customName?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ProductMode>;
  productId: Scalars['String']['input'];
  productInPackageId: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
};

export type UpdateProductPackage = {
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price: Array<InputMaybe<PriceConfigInput>>;
  printAndFileConfig: Array<InputMaybe<UpdatePrintAndFileConfig>>;
  productConfig: Array<InputMaybe<UpdateProductConfig>>;
  productPackageId?: InputMaybe<Scalars['ID']['input']>;
};

export enum UploadContext {
  BookingPortfolio = 'BookingPortfolio',
  ChatAttachment = 'ChatAttachment',
  CompetitionEntry = 'CompetitionEntry',
  ConfigTemplate = 'ConfigTemplate',
  CoverBooking = 'CoverBooking',
  CoverPrivate = 'CoverPrivate',
  CoverPublic = 'CoverPublic',
  DecorationFile = 'DecorationFile',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  FileWatermark = 'FileWatermark',
  ImageSampleForSessionFolder = 'ImageSampleForSessionFolder',
  LookBookPreview = 'LookBookPreview',
  Model3D = 'Model3D',
  OrganizationLogo = 'OrganizationLogo',
  OrganizationPromoFlyer = 'OrganizationPromoFlyer',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  PrivateSessionPackage = 'PrivateSessionPackage',
  Product = 'Product',
  ProductSampleOrder = 'ProductSampleOrder',
  PublicSessionChild = 'PublicSessionChild',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganizationLogo = 'PublicSessionOrganizationLogo',
  PublicSessionOrganizationMemberAvatar = 'PublicSessionOrganizationMemberAvatar',
  PublicSessionPackage = 'PublicSessionPackage',
  PublicSessionSignupCampaignPortfolio = 'PublicSessionSignupCampaignPortfolio',
  PublicSessionSignupPackagePortfolio = 'PublicSessionSignupPackagePortfolio',
  SupplierPrintsOrder = 'SupplierPrintsOrder',
  SupplierProductInOrder = 'SupplierProductInOrder',
  SupplierProductOrder = 'SupplierProductOrder',
  UserAvatar = 'UserAvatar',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}

export enum UploadFileType {
  CustomerOrder = 'CustomerOrder',
  Full = 'Full',
  Middle = 'Middle',
  Thumb = 'Thumb',
}

export type UploadQueue = {
  __typename?: 'UploadQueue';
  context: Maybe<Scalars['String']['output']>;
  contextId: Maybe<Scalars['String']['output']>;
  deviceId: Maybe<Scalars['String']['output']>;
  filesCount: Maybe<Scalars['Int']['output']>;
  filesDone: Maybe<Scalars['Int']['output']>;
  onDone: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  progress: Maybe<Scalars['Int']['output']>;
  queueId: Maybe<Scalars['String']['output']>;
  type: Maybe<UploadType>;
};

export enum UploadType {
  App = 'App',
  Browser = 'Browser',
}

export type UsedBookingPackageAddition = {
  __typename?: 'UsedBookingPackageAddition';
  affectDuration: Maybe<Scalars['Boolean']['output']>;
  affectPrice: Maybe<Scalars['Boolean']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  limit: Maybe<Scalars['Int']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  title: Maybe<Array<Maybe<CustomLabel>>>;
  usedBookingPackageAdditionId: Maybe<Scalars['ID']['output']>;
};

export type UsedBookingPackageAdditionInput = {
  affectDuration?: InputMaybe<Scalars['Boolean']['input']>;
  affectPrice?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  title?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
};

export enum UserTest {
  AntiAiWatermark = 'AntiAiWatermark',
  AutoSell = 'AutoSell',
  BigUpgrades = 'BigUpgrades',
  BookingLite = 'BookingLite',
  CampaignTrackedShootingCreation = 'CampaignTrackedShootingCreation',
  CountryPricePicker = 'CountryPricePicker',
  DidShop = 'DidShop',
  EmbedStore = 'EmbedStore',
  EmpikFoto = 'EmpikFoto',
  FilePricingAsSourceForPriceToAddToEveryFileInProduct = 'FilePricingAsSourceForPriceToAddToEveryFileInProduct',
  IdentityPhotoSell = 'IdentityPhotoSell',
  KrukBook = 'KrukBook',
  Notifications = 'Notifications',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  PermissionsCollection = 'PermissionsCollection',
  PrintOwnPhotos = 'PrintOwnPhotos',
  PrivateSession = 'PrivateSession',
  PrivateSessionLookBook = 'PrivateSessionLookBook',
  PublicSessionSignupCampaigns = 'PublicSessionSignupCampaigns',
  PublicSessionTemplates = 'PublicSessionTemplates',
  ScreenAppProtection = 'ScreenAppProtection',
  ScreenAppProtectionn = 'ScreenAppProtectionn',
  SellTriplex = 'SellTriplex',
  SellZalamoFrames = 'SellZalamoFrames',
  SnapPremiumPackage = 'SnapPremiumPackage',
  TabloDesigner = 'TabloDesigner',
  TestPremiumLab = 'TestPremiumLab',
  VisualGuides = 'VisualGuides',
  ZalamoPrintExperience = 'ZalamoPrintExperience',
  Csv = 'csv',
}

export enum VatType {
  Applied = 'Applied',
  Exempt = 'Exempt',
}

export type WallDecorPieceCrop = {
  __typename?: 'WallDecorPieceCrop';
  h: Maybe<Scalars['Float']['output']>;
  w: Maybe<Scalars['Float']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type WallDecorPieceCropInput = {
  h: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type WallDecorRenderPieceConfig = {
  __typename?: 'WallDecorRenderPieceConfig';
  crop: Maybe<WallDecorPieceCrop>;
  isFlip: Maybe<Scalars['Boolean']['output']>;
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  wallDecorPieceId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorRenderPieceConfigInput = {
  crop: WallDecorPieceCropInput;
  isFlip: Scalars['Boolean']['input'];
  photoGroupId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  wallDecorPieceId: Scalars['ID']['input'];
};

export type WallDecorRenderPreviewConfig = {
  __typename?: 'WallDecorRenderPreviewConfig';
  accessToken: Maybe<Scalars['ID']['output']>;
  color: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['ID']['output']>;
  images: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  wallDecorRenderPreviewConfigId: Maybe<Scalars['ID']['output']>;
  wallDecorSceneId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorRenderPreviewConfigInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  wallDecorSceneId?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkingHour = {
  __typename?: 'WorkingHour';
  day: Maybe<Scalars['Int']['output']>;
  endsAt: Maybe<Scalars['Int']['output']>;
  isWorking: Maybe<Scalars['Boolean']['output']>;
  startsAt: Maybe<Scalars['Int']['output']>;
  workingHourId: Maybe<Scalars['Int']['output']>;
};

export enum ZalamoObject {
  BookingPortfolio = 'BookingPortfolio',
  CompetitionEntry = 'CompetitionEntry',
  Conversation = 'Conversation',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  LookBookOrder = 'LookBookOrder',
  OldZalamoClient = 'OldZalamoClient',
  Order = 'Order',
  Organization = 'Organization',
  OrganizationClient = 'OrganizationClient',
  OrganizationPromoPrintFlyers = 'OrganizationPromoPrintFlyers',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  Product = 'Product',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganization = 'PublicSessionOrganization',
  PublicSessionOrganizationGroup = 'PublicSessionOrganizationGroup',
  SupportThread = 'SupportThread',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}

export type ZalamoPayP24RegisterInput = {
  addressCity: Scalars['String']['input'];
  addressPostCode: Scalars['String']['input'];
  addressStreet: Scalars['String']['input'];
  bankAccount: Scalars['String']['input'];
  businessType: Scalars['String']['input'];
  contactPersonName: Scalars['String']['input'];
  contactPersonPhoneNumber: Scalars['String']['input'];
  correspondenceAddressCity: Scalars['String']['input'];
  correspondenceAddressPostCode: Scalars['String']['input'];
  correspondenceAddressStreet: Scalars['String']['input'];
  krs: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nip: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  regon: Scalars['String']['input'];
  representatives: Array<InputMaybe<ZalamoPayP24RepresentativeInput>>;
};

export type ZalamoPayP24RepresentativeInput = {
  name: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
};

export type ZalamoPayRegisterResponse = {
  __typename?: 'ZalamoPayRegisterResponse';
  link: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type ZalamoPrintSessionConfig = {
  __typename?: 'ZalamoPrintSessionConfig';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  calendarPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  enabledTabloSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  magnetPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  sellCalendar: Maybe<Scalars['Boolean']['output']>;
  sellMagnet: Maybe<Scalars['Boolean']['output']>;
  sellTablo: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tabloPricing: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  zalamoPrintSessionConfigId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionConfigInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  calendarPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  enabledTabloSizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  magnetPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  sellCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sellMagnet?: InputMaybe<Scalars['Boolean']['input']>;
  sellTablo?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  tabloPricing?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
};

export type ZalamoPrintSessionTabloConfig = {
  __typename?: 'ZalamoPrintSessionTabloConfig';
  formatLabel: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  tabloIndex: Maybe<Scalars['Int']['output']>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfig = {
  __typename?: 'ZalamoPrintSessionTabloPricingConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfigInput = {
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  zalamoPrintSizeId?: InputMaybe<Scalars['ID']['input']>;
};
